export default "__VITE_ASSET__BXa9uVJz__"